module.exports = __webpack_public_path__ + "static/media/souls_of_samana.2c3ab433.svg";